import { HoldingClass, Operation, Society } from 'types';

type GetOperationNominalValueProps = {
  holdingClass: HoldingClass | null;
  operation: Operation;
  society: Society;
};

/**
 * Returns the nominal value from the first available source in this priority order:
 * 1. Holding class nominal value
 * 2. Transaction nominal value
 * 3. Society nominal value
 * 4. Default to 0 if none of the above are available
 */
export const getOperationNominalValue = ({
  holdingClass,
  operation,
  society,
}: GetOperationNominalValueProps): number =>
  holdingClass?.nominalValue ??
  operation?.nominalValue ??
  society?.nominalValue ??
  0;
